// src/hooks/useCrmClientPermissions.ts
import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { CRM_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Permisos del menú Gestión de clientes (client-management).
 */
export const useCrmClientPermissions = () => {
  const canView = usePermission(CRM_PERMISSIONS.VIEW);
  const canAdd = usePermission(CRM_PERMISSIONS.ADD);
  const canEdit = usePermission(CRM_PERMISSIONS.EDIT);
  const canExport = usePermission(CRM_PERMISSIONS.EXPORT);
  const canDelete = usePermission(CRM_PERMISSIONS.DELETE);

  return useMemo(
    () => ({
      canView,
      canAdd,
      canEdit,
      canExport,
      canDelete,
    }),
    [canView, canAdd, canEdit, canExport, canDelete],
  );
};
